import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import i18n from 'i18n-js';
import ScanLanding from './ScanLanding';
import {assignToteSet} from '../../actions/productFirstActions';
import {selectToteIdentifier} from '../../selectors/productFirstSelectors';

const ClaimWallScreen = () => {
  const dispatch = useDispatch();
  const toteIdentifier = useSelector(selectToteIdentifier);
  const input = useSelector(state => state.productFirst.input);

  return (
    <ScanLanding
      caption={i18n.t('productFirst.claimHeading', {toteIdentifier})}
      placeholder={i18n.t('productFirst.claimPlaceholder', {toteIdentifier})}
      onSubmit={() => dispatch(assignToteSet(input))}
    />
  );
};

export default ClaimWallScreen;
